// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

import "core-js/stable"
import "regenerator-runtime/runtime"

import 'bootstrap';

import '@fortawesome/fontawesome-free/js/all'
import 'react-app-polyfill/ie11';

import '../javascripts/map/map.tsx';
import '../javascripts/initial_reports.tsx';
import '../javascripts/ministry_mail.tsx';

import '../javascripts/application';

import '../stylesheets/application.scss';
import 'leaflet/dist/leaflet.css';
import 'react-leaflet-markercluster/dist/styles.min.css'

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
